// timeout for resize event
function debouncer(func, timeout) {
    var timeoutID, timeout = timeout || 500;
    return function() {
        var scope = this,
            args = arguments;
        clearTimeout(timeoutID);
        timeoutID = setTimeout(function() {
            func.apply(scope, Array.prototype.slice.call(args));
        }, timeout);
    }
}

$(document).ready(function() {

      $('#cardsearch-container #cardterm').watermark('TYPE YOUR GAME HERE!', { 
        className: 'carsearch-watermark', color: '#e2e2e2'
         });
});